const sendExternalEvent = (category, action, label) => {};

export default sendExternalEvent;
